import { useState } from 'react'
import { EnterFeedback } from '../enter-feedback/EnterFeedback'
import { AppNames } from '../../types/types'
import { ChatCenteredDotsIcon, Mtds } from 'prove-common'

type UserFeedbackProps = {
  appName: AppNames
}

export const UserFeedback = ({ appName }: UserFeedbackProps) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      {!isOpen && (
        <Mtds.Button
          id={'user-feedback-button'}
          aria-label='Åpne vindu for å gi tilbakemeldinger'
          className='fixed right-8 bottom-8 z-1000'
          data-color={'neutral'}
          data-variant='primary'
          onClick={() => setIsOpen(true)}
        >
          <ChatCenteredDotsIcon />
        </Mtds.Button>
      )}
      {isOpen && (
        <EnterFeedback appName={appName} isOpen={isOpen} setOpen={setIsOpen} />
      )}
    </div>
  )
}
